import { render, staticRenderFns } from "./eliminarProducto.vue?vue&type=template&id=21419744&scoped=true&lang=html&"
import script from "./eliminarProducto.vue?vue&type=script&lang=js&"
export * from "./eliminarProducto.vue?vue&type=script&lang=js&"
import style0 from "./eliminarProducto.vue?vue&type=style&index=0&id=21419744&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21419744",
  null
  
)

export default component.exports